import * as tslib_1 from "tslib";
import { getStore as getSharedFavoriteStore } from 'owa-favorites';
import { getPersonaNodeIdFromExtendedProperty } from 'owa-mail-persona-search-folder-services';
import folderStore from 'owa-folders';
import { action } from 'satcheljs/lib/legacy';
export default action('setupFavoritePersona')(function setupFavoritePersona(personaSearchFolder) {
    var favoriteNodeId = getPersonaNodeIdFromExtendedProperty(personaSearchFolder);
    // The persona search folder includes a guid in the displayName which surfaces
    // in certain dialogs, for example "Delete All". By changing the display name here,
    // the folder doesn't need any special treatment.
    var favoritePersona = getSharedFavoriteStore().favoritesPersonaNodes.get(favoriteNodeId);
    if (favoritePersona) {
        var displayName = favoritePersona.displayName;
        var searchFolder = tslib_1.__assign({}, personaSearchFolder, { DisplayName: displayName });
        folderStore.folderTable.set(personaSearchFolder.FolderId.Id, searchFolder);
        var newSearchFolderId = searchFolder.FolderId.Id;
        if (favoritePersona.searchFolderId !== newSearchFolderId) {
            favoritePersona.searchFolderId = newSearchFolderId;
        }
    }
});
//# sourceMappingURL=setupFavoritePersona.js.map